'use client'

import { useModals } from '@/lib/hooks'
import type React from 'react'

import {
  AddCartDiscountModal,
  AddCartItemSerialModal,
  AddToCartModal,
  CloseRegisterModal,
  ConfirmNoWarrantyModal,
  ConfirmPaymentModal,
  CreateCustomerModal,
  CustomReferenceModal,
  EditCartItemModal,
  EmailReceiptModal,
  FuturePaymentDateAndReferenceModal,
  FuturePaymentDateModal,
  GiftCardReferenceModal,
  OpenRegisterModal,
  PaymentCardVerificationModal,
  PrintReceiptModal,
  PrintReturnReceiptModal,
  ReturnOrderModal,
  SMSReceiptModal,
  SelectNewOrderOptionsModal,
  SelectOtherPaymentTypeModal,
  SelectPaymentCardTypeModal,
  ViewCartPaymentsModal,
} from '@/components/modals'

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const { modals } = useModals()

  return (
    <>
      {children}

      <EditCartItemModal open={modals.includes('EDIT_CART_ITEM')} />

      <ConfirmNoWarrantyModal open={modals.includes('CONFIRM_NO_WARRANTY')} />

      <AddCartItemSerialModal open={modals.includes('ADD_CART_ITEM_SERIAL')} />

      <ReturnOrderModal open={modals.includes('RETURN_ORDER')} />

      <OpenRegisterModal open={modals.includes('OPEN_REGISTER')} />

      <CloseRegisterModal open={modals.includes('CLOSE_REGISTER')} />

      <AddToCartModal open={modals.includes('ADD_TO_CART')} />

      <ConfirmPaymentModal open={modals.includes('CONFIRM_PAYMENT')} />

      <ViewCartPaymentsModal open={modals.includes('VIEW_CART_PAYMENTS')} />

      <PrintReceiptModal open={modals.includes('PRINT_RECEIPT')} />

      <PrintReturnReceiptModal
        open={modals.includes('PRINT_RETURN_RECEIPT')}
      />

      <CreateCustomerModal open={modals.includes('CREATE_CUSTOMER')} />

      <SelectPaymentCardTypeModal
        open={modals.includes('SELECT_PAYMENT_CARD_TYPE')}
      />

      <PaymentCardVerificationModal
        open={modals.includes('PAYMENT_CARD_VERIFICATION')}
      />

      <SelectOtherPaymentTypeModal
        open={modals.includes('SELECT_OTHER_PAYMENT_TYPE')}
      />

      <FuturePaymentDateModal open={modals.includes('FUTURE_PAYMENT_DATE')} />

      <CustomReferenceModal open={modals.includes('CUSTOM_REFERENCE')} />

      <GiftCardReferenceModal open={modals.includes('GIFT_CARD_REFERENCE')} />

      <FuturePaymentDateAndReferenceModal
        open={modals.includes('FUTURE_PAYMENT_DATE_AND_REFERENCE')}
      />

      <SelectNewOrderOptionsModal
        open={modals.includes('SELECT_NEW_ORDER_OPTIONS')}
      />

      <AddCartDiscountModal open={modals.includes('ADD_CART_DISCOUNT')} />

      <EmailReceiptModal open={modals.includes('EMAIL_RECEIPT')} />

      <SMSReceiptModal open={modals.includes('SMS_RECEIPT')} />
    </>
  )
}
